import React, { useState, useEffect } from "react";
import { Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useGetAllEventsPaginationMutation } from "../../app/services/eventService";
import { selectCurrentMember } from "../../app/features/memberSlice";
import { useNavigate, useParams } from "react-router-dom";
import { selectCurrentScope } from "../../app/auth/authSlice";
import Spinner from "../../Component/spinner/spinner";

const Event = ({ chapterID }) => {
  const [eventDetails, setEventDetails] = useState([]);
  const [getAllEvents] = useGetAllEventsPaginationMutation();
  const { sigGroupId } = useParams();
  const memberDetails = useSelector(selectCurrentMember);
  const currentScope = useSelector(selectCurrentScope);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    //fetch event Details
    const fetchEvents = async () => {
      const arg = {
        page: 1, itemsPerPage: '', chapterId: chapterID ?? '', sigId: sigGroupId ?? ''
      }
      try {
        const res = await getAllEvents(arg);
        const data = res?.data?.data?.eventDetails;
        setEventDetails(data);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, [
    getAllEvents,
    chapterID,
    sigGroupId,
  ]);

  //REGISTER BUTTON
  const registeredBtn = (event) => {
    const membersId = event?.membersId;
    const memberRegister = membersId ? membersId.filter((id) => id === memberDetails?._id) : [];
    if (memberRegister.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  // on click the event have to route to the view event page
  const viewevent = (eventId) => {
    if (currentScope === "PORTAL_SIG_ADMIN") {
      navigate("/sigAdmin/VieweventFeed/" + eventId);
    } else if (currentScope === "PORTAL_SUPER_ADMIN") {
      navigate("/admin/VieweventFeed/" + eventId);
    } else if (currentScope === "PORTAL_MEMBER") {
      navigate("/member/VieweventFeed/" + eventId);
    } else if (currentScope === "PORTAL_CHAPTER_ADMIN") {
      navigate("/chapterAdmin/VieweventFeed/" + eventId);
    }
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {eventDetails?.length > 0 ? (
            eventDetails.map((event) => (
              <Card
                key={event?._id}
                className="onclick"
                sx={{
                  position: "relative",
                  maxWidth: "90%",
                  mx: "auto",
                  boxShadow: "none",
                  background: "transparent",
                }}
                onClick={() => viewevent(event?._id)}
              >
                {registeredBtn(event) && (
                  <span
                    style={{
                      right: "0%",
                      top: "40%",
                      marginTop: "17px",
                      padding: "8px",
                      backgroundColor: "#333",
                    }}
                    className="position-absolute top-0 translate-middle badge"
                  >
                    Registered
                    <span className="visually-hidden">Registered</span>
                  </span>
                )}
                <CardContent>
                  <div
                    style={{
                      border: "1px solid #a52a2a",
                      borderRadius: "15px",
                      padding: "10px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={4} style={{ position: "relative" }}>
                        <div style={{ position: "relative" }}>
                          <CardMedia
                            component="img"
                            height="160"
                            image={event?.imageUrl}
                            alt="Tab 1 Image"
                            style={{
                              objectFit: "cover",
                              borderRadius: "15px",
                            }}
                          />
                          <Typography
                            variant="h6"
                            style={{
                              position: "absolute",
                              left: "18%",
                              bottom: "7%",
                              color: "#fff",
                              background: "#611f1e",
                              padding: "5px 10px",
                              borderRadius: "8px",
                            }}
                          >
                            Speaker:{" "}
                            {event?.speakers && event?.speakers[0]?.name}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant="h5" color="#a52a2a">
                          {event?.title}
                        </Typography>
                        <Typography variant="body2">
                          {event?.description ? event.description.replace(/<[^>]+>/g, "").slice(0, 50) : ""}
                          ...
                        </Typography>
                        <div
                          className="d-flex justify-content-end"
                          style={{
                            color: "#a52a2a",
                            position: "absolute",
                            bottom: "10%",
                            left: "50%",
                            fontWeight: "bold",
                          }}
                        >
                          Start Date:{" "}
                          {event?.startDate
                            .split("T")[0]
                            .split("-")
                            .reverse()
                            .join("-")}{" "}

                          End Date:{" "}
                          {event?.endDate
                            ? event.endDate.split("T")[0].split("-").reverse().join("-")
                            : "---"}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </CardContent>
              </Card>
            ))
          ) : (
            <p className="text-black fs-2 text-capitalize lead text-center">
              Will Be Added Shortly
            </p>
          )}
        </>
      )}
    </>
  );
};

export default Event;
